module.exports = __webpack_public_path__ + "img/tuiguangtop.58fc686f.png";